import { ASYNC_TYPES } from '@travel-frontend/state-handling-sdk';
import axios from 'axios';
import { ADD_TO_WISHLIST, FETCH_WISHLIST_METADATA, REMOVE_FROM_WISHLIST, SYNC_SESSION_WITH_CUSTOMER } from '../../../../components/Wishlist/redux/wishlist-meta/models.js';
export function fetchWishlistMetadata(url, identifierId, identifierType) {
  return {
    types: ASYNC_TYPES(FETCH_WISHLIST_METADATA),
    callAPI: () => axios.get(`${url}/${identifierType}/${identifierId}/meta`).then(res => res.data)
  };
}
export function addToWishlist({
  url,
  identifierId,
  identifierType,
  listId,
  hotelId,
  onSuccess,
  onError
}) {
  return {
    types: ASYNC_TYPES(ADD_TO_WISHLIST),
    callAPI: () => axios.post(`${url}/${identifierType}/${identifierId}/list/${listId}/hotel/${hotelId}`).then(res => {
      onSuccess?.();
      return res.data;
    }).catch(error => {
      onError?.(error);
      throw error;
    }),
    hotelId
  };
}
export function removeFromWishlist({
  url,
  identifierId,
  identifierType,
  listId,
  hotelId,
  onSuccess,
  onError
}) {
  return {
    types: ASYNC_TYPES(REMOVE_FROM_WISHLIST),
    callAPI: () => axios.delete(`${url}/${identifierType}/${identifierId}/list/${listId}/hotel/${hotelId}`).then(res => {
      onSuccess?.();
      return res.data;
    }).catch(error => {
      onError?.(error);
      throw error;
    }),
    hotelId
  };
}
export function syncSessionWithCustomer(url, customerId, sessionId) {
  return {
    types: ASYNC_TYPES(SYNC_SESSION_WITH_CUSTOMER),
    callAPI: () => axios.post(`${url}/customer/${customerId}/session/${sessionId}`).then(res => res.data),
    customerId
  };
}